import { Role } from '@auth/enums/role.enum';
import { Url } from '@core/enums/url.enum';

export const DEFAULT_ROUTES_BY_ROLE: Record<Role, string> = {
  Admin: Url.AdminEmployeeProfiles,
  FullContractor: Url.ContractorEmployeeProfiles,
};
